<template>
  <div class="col-12">
    <img alt="Dr Wisniewska" src="../assets/dr_wisniewska_r.jpg" class="img-fluid rounded-circle">
    <h3 class="welcome pt-1 pb-3">Dr Małgorzata Beata Wiśniewska</h3>
    <div class="row mb-5">
      <div class="col-12 col-md-6">
          <h6 class="text-left">Jako pediatra w Top Medical Clinic  pani doktor zajmuje się:</h6>
          <ul class="text-left pt-2">
              <li v-for="item in pediatra">{{item}}</li>
          </ul>
      </div>
      <div class="col-12 col-md-6 text-left">
          <h6>W zakresie medycyny estetycznej  dr Wiśniewska oferuje:</h6>
          <ul class="text-left pt-2">
              <li v-for="item in medycyna">{{item}}</li>
          </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    data() {
        return {
            pediatra: [
                'pełną diagnostyką dziecka od noworodka do 18 roku życia',
                'noworodkami z ryzyka okołoporodowego',
                'kwalifikacją do szczepień',
                'bilansem zdrowego dziecka',
                'diagnostyką „małej laryngologii”',
                'prowadzeniem dzieci z alergią, atopowym zapaleniem skóry oraz astmą oskrzelową',
                'diagnostyką i leczeniem ostrych i przewlekłych infekcji dróg moczowych.'
            ],
            medycyna: [
                'profesjonalną ocenę stanu skóry i doradztwo odnośnie wyboru zabiegu',
                'doradztwo i dobór zabiegu w przypadku przebarwień oraz blizn pooperacyjnych i potrądzikowych',
                'zabiegi wygładzania zmarszczek (toksyna botulinowa, dermafilery, mezoterapia)',
                'mezoterapię -różnorodne koktaile, PRP (Wampirzy Lifting)',
                'biostymulatory kolagenu, fibryny i elastyny',
                'modelowanie twarzy, korektę nosa i brody, modelowanie ust',
                'zastosowanie toksyny botulinowej typ A w nadpotliwości oraz bruksiźmie',
                'peelingi chemiczne',
                'Cosmelan / Dermamelan',
                'lipolizę iniekcyjną depozytów tkanki tłuszczowej',
                'nici PDO',
                'oraz wiele innych zabiegów, które Pani doktor zaoferuje w zależności od potrzeb pacjenta'
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
.welcome {
  font-weight: 400;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
img { width: 200px;}
</style>
